import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { popUpMessageChange, 
        editCards, 
        deleteCards, 
        editFeaturesGroup, 
        editFigures,
        toggleSwitch,
        selectedCardsGroupsChange } from '../../actions';

import { _ } from '../../functions/translator.js';

import { Button } from '@material-ui/core';
import { Form } from 'react-bootstrap';
import { CircularProgress } from '@material-ui/core'
import SendIcon from '@material-ui/icons/Send';

import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';
import { ToggleActions } from '../../constants/constants.js';

const TunnelSubdivisions = (props) => {
    const [showLoading, setShowLoading] = useState(false);

    const handleSubmit = async (e) => {
        const message = _("Subdividiendo el registro") + '...';
        showMessage(props, message, { loading: true });
        handleClose();
        try {
            const formData = new FormData(e.target);
            const subdivision_length = formData.get('subdivision_length');
            const start = formData.get('start');
            const end = formData.get('end');
            const urlPost = {
                project_id: props.projectData.id,
                cards_group_id: props.selectedCardsGroups[0],
                subdivision_length,
                start,
                end,
            };
            
            const response = await postData('/web-api/transform-cardsgroup-into-tunnel', urlPost, 'Error en la solicitud');
            handleResponse(response);

        } catch (error) {
            console.error('Error:', error);
        } finally {
            props.selectedCardsGroupsChange([]);
            setShowLoading(false)
        }
    };

    const handleClose = () => {
        props.toggleSwitch(ToggleActions.TUNNEL_SUBDIVISION, false);
        props.selectedCardsGroupsChange([]);
    };

    const handleResponse = async (response) => {
        if (response && response.status === 'success') {
            reloadCardsGroupsFeatures(props, props.selectedCardsGroups);
            showMessage(props, '¡' + _('Se ha subdividido el registro correctamente') + '!');
        } else {
            showMessage(props, _('No se pudo subdividir el registro') + '.');
        }
    };


    const render = props.tunnelSubdivisions;
    if (!render) return <div></div>;

    return (
        <div>
            <div className='sensitive-background' onClick={handleClose}></div>
            <div className="add-cards-groups-card-layout card-color">
                <h3 className='text-center mt-2 mb-4'>{_("Subdividir Registro")}</h3>
                <Form method="POST" onSubmit={handleSubmit}>
                    <Form.Group className='mt-2' controlId="subdivision_length">
                        <Form.Label>{_('Cada cuanto subdividir')} (mts):</Form.Label>
                        <Form.Control 
                            type="number"
                            name="subdivision_length" 
                            min="0" 
                            required/>
                    </Form.Group>
                    <Form.Group className='mt-2' controlId="start">
                        <Form.Label>{_('Inicio')}:</Form.Label>
                        <Form.Control 
                            type="number"
                            name="start" 
                            min="0" 
                            step="any"
                            required/>
                    </Form.Group>
                    <Form.Group className='mt-2' controlId="end">
                        <Form.Label>{_('Fin')}:</Form.Label>
                        <Form.Control 
                            type="number"
                            name="end" 
                            min="0" 
                            step="any"
                            required/>
                    </Form.Group>
                    <div className='d-flex justify-content-center mt-3 mb-1'>
                        <div style={{ position: 'relative' }}>
                            <Button type="submit" variant="contained" className='success-button mt-4'>
                                <SendIcon />
                                <span style={{ paddingLeft: 10 }}>{_('Subdividir')}</span>
                            </Button>
                            {showLoading && 
                                <div style={{ position: 'absolute', top: '20%', right: '-25px' }}>
                                    <CircularProgress style={{ width:'20px', height:'20px' }} />
                                </div>
                            }
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        projectData         : state.projectData,
        popup               : state.popup,
        popUpMenu           : state.popUpMenu,
        day                 : state.day,
        cardCategoryIds     : state.filters.cardCategoryIds,
        protocolsIds        : state.filters.protocolIds,
        status              : state.filters.status,
        customcardId        : state.filters.customcardId,
        userRole            : state.userRole,
        selectedCardsGroups : state.selectedCardsGroups,
        qualityProgress     : state.qualityProgress,
        zoneIds             : state.filters.zoneIds,
        editMode            : state.switches.editMode,
        activeTab           : state.activeTab,
        stageIds            : state.filters.stageIds,
        tunnelSubdivisions  : state.switches.tunnelSubdivisions,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleSwitch,
        selectedCardsGroupsChange,
        popUpMessageChange,
        deleteCards,
        editCards,
        editFeaturesGroup,
        editFigures
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(TunnelSubdivisions);